export default __webpack_public_path__ + "static/media/close.c4147523.svg";